"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropListItemSeparator = void 0;
var React = require("react");
var DropList_styles_1 = require("./DropList.styles");
var DropListItemSeparator = function () {
    return React.createElement(DropList_styles_1.MenuRow, { role: "none" },
        React.createElement(DropList_styles_1.Hr, null));
};
exports.DropListItemSeparator = DropListItemSeparator;
